webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HelpUs__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HelpUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_HelpUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Search__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Term__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Term___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Term__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
    }, {
        path: '/about',
        name: 'About',
        component: __WEBPACK_IMPORTED_MODULE_3__components_About___default.a
    }, {
        path: '/helpus',
        name: 'HelpUs',
        component: __WEBPACK_IMPORTED_MODULE_4__components_HelpUs___default.a
    }, {
        path: '/search/:term',
        name: 'search',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Search___default.a
    }, {
        path: '/term/:id',
        name: 'term',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Term___default.a
    }]

}));

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cv/messages.js": 14,
	"./eo/messages.js": 15,
	"./ru/messages.js": 16
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var term;
var newterm;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            search: true,
            buttons: ['ӑ', 'ӗ', 'љ', 'њ', 'р̌', 'ҫ', 'т̌', 'ӳ', 'ђ'],
            counter: { 'count': 0 },
            lastterms: null
        };
    },
    created: function created() {
        term = $('#search-field').val();
        this.fetchAll();
    },

    methods: {
        fetchAll: function fetchAll() {
            this.fetchCounter();
            this.fetchLastTerms();
        },
        fetchCounter: function fetchCounter() {
            var _this = this;

            this.$http.get('https://samahsar.cv-haval.org/custom/count').then(function (response) {
                _this.counter = response.body;
            }, function (response) {
                _this.counter = '!';
            });
        },
        fetchLastTerms: function fetchLastTerms() {
            this.lastterms = this.$cookies.get('lastterms') ? this.$cookies.get('lastterms').split(':') : [];
        },
        searchTerm: function searchTerm() {
            newterm = $('#search-field').val();
            if (newterm && newterm !== term) {
                this.updateCookies(newterm);
                this.$router.push({ name: 'search', params: { term: newterm } });
            }
        },
        eraseTerm: function eraseTerm() {
            term = $('#search-field').val('');
            this.$router.push({ path: '/' });
            this.fetchLastTerms();
        },
        pressButton: function pressButton(event) {
            var result = $('#search-field').val() + event.target.innerText;
            $('#search-field').val(result);
        },
        updateCookies: function updateCookies(newterm) {
            var cookie = this.$cookies.get('lastterms');
            var arr;
            if (cookie !== null) {
                cookie = cookie + ':';
                cookie = cookie + newterm;

                arr = cookie.split(':');
                $.uniqueSort(arr);
                arr = arr.slice(-10);
                cookie = arr.join(':');
            } else {
                cookie = newterm;
            }

            this.$cookies.set('lastterms', cookie, 60 * 60 * 24, '/');
            this.lastterms = cookie.split(':');
        },
        toggleLang: function toggleLang(lang) {
            if (this.$lang.getLang() !== lang) {
                this.$lang.setLang(lang);
                this.$cookies.set('lang', lang, 60 * 60 * 24, '/');
            }
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'about',
    data: function data() {
        return {
            loading: false,
            page: null,
            error: null
        };
    },
    created: function created() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.error = this.page = null;
            this.loading = true;

            this.$http.get('https://samahsar.cv-haval.org/custom/info?type=about').then(function (response) {
                _this.loading = false;
                _this.page = response.body;
            }, function (response) {
                _this.loading = false;
                _this.error = true;
            });
        }
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'helpus',
    data: function data() {
        return {
            loading: false,
            page: null,
            error: null
        };
    },
    created: function created() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.error = this.page = null;
            this.loading = true;

            this.$http.get('https://samahsar.cv-haval.org/custom/info?type=helpus').then(function (response) {
                _this.loading = false;
                _this.page = response.body;
            }, function (response) {
                _this.loading = false;
                _this.error = true;
            });
        }
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    data: function data() {
        return {
            inscription: {},
            lastterms: null,
            loading: null,
            notfound: null,
            error: null
        };
    },
    created: function created() {
        this.fetchLastTerms();
        this.getInscriptions();
    },
    updated: function updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },

    watch: {
        '$route': 'fetchLastTerms',
        '$lang.current_lang': function $langCurrent_lang() {
            this.getInscriptions();
        }
    },
    methods: {
        fetchLastTerms: function fetchLastTerms() {
            var _this = this;

            this.error = this.randomterms = null;
            this.loading = true;

            this.$http.get('https://samahsar.cv-haval.org/custom/lastterms').then(function (response) {
                _this.loading = false;
                _this.lastterms = response.body;
            }, function (response) {
                _this.loading = false;
                _this.error = true;
            });
        },
        getInscriptions: function getInscriptions() {
            this.inscription = {
                'last_added_articles': this.$lang.messages.last_added_articles,
                'more_text': this.$lang.messages.more_text
            };
        }
    }

});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',
    data: function data() {
        return {
            loading: false,
            content: null,
            error: null,
            notfound: null
        };
    },
    created: function created() {
        this.fetchData();
    },

    watch: {
        '$route': 'fetchData',
        '$lang.current_lang': function $langCurrent_lang() {
            this.$forceUpdate();
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.error = this.content = this.notfound = null;
            this.loading = true;
            var newterm = this.$route.params.term;
            $('#search-field').val(newterm);
            this.$http.get('https://samahsar.cv-haval.org/custom/search?term=' + newterm).then(function (response) {
                _this.loading = false;
                if (!$.isEmptyObject(response.body)) {
                    _this.content = response.body;
                } else {
                    _this.notfound = true;
                }
            }, function (response) {
                _this.loading = false;
                _this.error = true;
            });
        }
    }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'term',
    data: function data() {
        return {
            loading: false,
            content: null,
            pager: null,
            error: null
        };
    },
    created: function created() {
        this.fetchData();
    },

    watch: {
        '$route': 'fetchData',
        '$lang.current_lang': function $langCurrent_lang() {
            this.$forceUpdate();
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.error = this.content = null;
            this.loading = true;

            this.$http.get('https://samahsar.cv-haval.org/custom/view?id=' + this.$route.params.id).then(function (response) {
                _this.loading = false;
                _this.pager = { 'next': response.body.pop(), 'prev': response.body.pop() };
                _this.content = response.body.pop();
            }, function (response) {
                _this.loading = false;
                _this.error = true;
            });
        }
    }
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {
  'about': 'Сайт ҫинчен',
  'for_helpers': 'Пулӑшуçă валли',
  'menu': 'Менӳ',
  'history': 'Истори',
  'search_word': 'Сăмаха çырăр...',
  'n_i_ashmarin': 'Н.И. Ашмарин',
  'chuvash_dictionary': 'Чӑваш сӑмахӗсен кӗнеки',
  'articles_on_site': 'Сайтри статья шучӗ',
  'last_added_articles': 'Хальтерех кӗртнӗ статьясем',
  'haval_org': '"Хавал" чăваш халăх пĕрлешĕвĕ',
  'more_text': 'Туллин...'
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {
  'about': 'Pri la retejo',
  'for_helpers': 'Por helpantoj',
  'menu': 'Menuo',
  'history': 'Historio',
  'search_word': 'Serĉi la vorton...',
  'n_i_ashmarin': 'N.I. Aŝmarin',
  'chuvash_dictionary': 'Vortaro de la Ĉuvaŝa lingvo',
  'articles_on_site': 'Kuranta kvanto de vort-artkoloj',
  'last_added_articles': 'Laste aldonitaj vort-artikoloj',
  'haval_org': 'Ĉuvaŝa socia organizo "Ĥaval"',
  'more_text': 'Plu...'
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {
  'about': 'О сайте',
  'for_helpers': 'Помощникам',
  'menu': 'Меню',
  'history': 'История',
  'search_word': 'Искать слово...',
  'n_i_ashmarin': 'Н.И. Ашмарин',
  'chuvash_dictionary': 'Словарь чувашского языка',
  'articles_on_site': 'Словарных статей на сайте',
  'last_added_articles': 'Последние добавленные статьи',
  'haval_org': 'Чувашская общественная организация "Хавал"',
  'more_text': 'Далее...'
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_localization__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_localization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_localization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(2);








__WEBPACK_IMPORTED_MODULE_1_vuejs_localization___default.a.requireAll(__webpack_require__(7));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuejs_localization___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookies___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
  created: function created() {
    if (!this.$cookies.isKey('lastterms')) {
      this.$cookies.set('lastterms', '', 60 * 60 * 24, '/');
    }
    if (!this.$cookies.isKey('lang')) {
      this.$lang.setLang('ru');
      this.$cookies.set('lang', 'ru', 60 * 60 * 24, '/');
    } else {
      this.$lang.setLang(this.$cookies.get('lang'));
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  "data-v-dac44e1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  "data-v-8ae13dac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(21)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  "data-v-559db10a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  "data-v-441f9c93",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  "data-v-2c267217",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "term"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Ошибка Получения данных!")]) : _vm._e(), _vm._v(" "), (_vm.pager) ? _c('nav', {
    attrs: {
      "id": "pager-block"
    }
  }, [_c('ul', {
    staticClass: "pager"
  }, [(_vm.pager.prev.id) ? _c('li', {
    staticClass: "previous"
  }, [_c('a', {
    attrs: {
      "href": '#/term/' + _vm.pager.prev.id
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.pager.prev.term))])]) : _vm._e(), _vm._v(" "), (_vm.pager.next.id) ? _c('li', {
    staticClass: "next"
  }, [_c('a', {
    attrs: {
      "href": '#/term/' + _vm.pager.next.id
    }
  }, [_vm._v(_vm._s(_vm.pager.next.term) + " "), _c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "panel panel-default margin-bottom"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.content.word_orig))]), _vm._v(" "), _c('small', [_vm._v("[" + _vm._s(_vm.content.volume) + " : " + _vm._s(_vm.content.fpage)), (_vm.content.fpage !== _vm.content.lpage) ? _c('span', [_vm._v(" - " + _vm._s(_vm.content.lpage))]) : _vm._e(), _vm._v("]")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-justify",
    domProps: {
      "innerHTML": _vm._s(_vm.content.word_desc)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.content.word_desc) + "                  \n                ")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#infoModal",
      "title": "Сообщить об ошибке!"
    }
  }, [_c('span', {
    staticClass: "fa fa-exclamation-triangle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "margin-top",
    attrs: {
      "id": "result"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Ошибка Получения данных!")])]) : _vm._e(), _vm._v(" "), (_vm.notfound) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Не удалось найти статью в словаре!")])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "success"
  }, _vm._l((_vm.content), function(article) {
    return _c('div', {
      staticClass: "panel panel-default margin-bottom"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('strong', [_c('a', {
      attrs: {
        "href": '#/term/' + article.id
      }
    }, [_vm._v(_vm._s(article.word_orig))])]), _vm._v(" "), _c('small', [_vm._v("[" + _vm._s(article.volume) + " : " + _vm._s(article.fpage)), (article.fpage !== article.lpage) ? _c('span', [_vm._v(" - " + _vm._s(article.lpage))]) : _vm._e(), _vm._v("]")]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "panel-body text-justify",
      domProps: {
        "innerHTML": _vm._s(article.word_desc)
      }
    }, [_vm._v("\n                        " + _vm._s(article.word_desc) + "                  \n                    ")])])
  })) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#infoModal",
      "title": "Сообщить об ошибке!"
    }
  }, [_c('span', {
    staticClass: "fa fa-exclamation-triangle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/"
    }
  }, [_c('span', {
    staticClass: "first"
  }, [_vm._v(_vm._s(_vm.$lang.messages.n_i_ashmarin))]), _c('span', {
    staticClass: "second"
  }, [_vm._v(" * ")]), _c('span', {
    staticClass: "third"
  }, [_vm._v(_vm._s(_vm.$lang.messages.chuvash_dictionary))])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "menu-block"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$lang.getLang()))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.$lang.getLang() != 'cv') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('cv')
      }
    }
  }, [_c('a', [_vm._v("cv")])]) : _vm._e(), _vm._v(" "), (_vm.$lang.getLang() != 'ru') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('ru')
      }
    }
  }, [_c('a', [_vm._v("ru")])]) : _vm._e(), _vm._v(" "), (_vm.$lang.getLang() != 'eo') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('eo')
      }
    }
  }, [_c('a', [_vm._v("eo")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.menu))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.about))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpus"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.for_helpers))])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.search) ? _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "search"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "id": "erase-btn",
      "type": "button"
    },
    on: {
      "click": _vm.eraseTerm
    }
  }, [_c('span', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "id": "search-field",
      "type": "text",
      "name": "term",
      "placeholder": _vm.$lang.messages.search_word
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTerm($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "id": "search-btn",
      "type": "button"
    },
    on: {
      "click": _vm.searchTerm
    }
  }, [_c('span', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "id": "sidebar-btn"
    }
  }, [(_vm.lastterms.length > 0) ? _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs dropdown-toggle btn-history",
    attrs: {
      "type": "button",
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$lang.messages.history) + "\n                        "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu1"
    }
  }, _vm._l((_vm.lastterms), function(lastterm) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/search/' + lastterm
      }
    }, [_vm._v(_vm._s(lastterm))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 button-block text-center",
    attrs: {
      "id": "buttons"
    }
  }, _vm._l((_vm.buttons), function(button) {
    return (_vm.buttons) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-chuv",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.pressButton
      }
    }, [_vm._v(_vm._s(button))]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 wcounter text-right",
    attrs: {
      "id": "wcounter"
    }
  }, [_c('span', {
    staticClass: "third-part"
  }, [_vm._v(_vm._s(_vm.$lang.messages.articles_on_site) + ": "), (_vm.counter) ? _c('label', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.counter.count))]) : _vm._e()])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("© " + _vm._s(_vm.$lang.messages.haval_org) + ", 2017")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#menu-block",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('h4', {
    staticClass: "inscription"
  }, [_vm._v(_vm._s(_vm.inscription.last_added_articles) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top",
    attrs: {
      "id": "result"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("Ошибка Получения данных!")])]) : _vm._e(), _vm._v(" "), (_vm.lastterms) ? _c('div', {
    staticClass: "lastterms"
  }, _vm._l((_vm.lastterms), function(rows) {
    return (_vm.lastterms.length > 0) ? _c('div', {
      staticClass: "row"
    }, _vm._l((rows), function(item) {
      return _c('div', {
        staticClass: "col-sm-4"
      }, [_c('div', {
        staticClass: "panel panel-default"
      }, [_c('div', {
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "article_short_text",
        domProps: {
          "innerHTML": _vm._s(item.word_desc)
        }
      }, [_vm._v(_vm._s(item.word_desc))]), _vm._v(" "), _c('a', {
        staticClass: "small",
        attrs: {
          "href": '#/term/' + item.id
        }
      }, [_vm._v(_vm._s(_vm.inscription.more_text))])]), _vm._v(" "), _c('div', {
        staticClass: "panel-footer"
      }, [_c('small', [_vm._v("[" + _vm._s(item.volume) + " : " + _vm._s(item.fpage)), (item.fpage !== item.lpage) ? _c('span', [_vm._v(" - " + _vm._s(item.lpage))]) : _vm._e(), _vm._v("]")])])])])
    })) : _vm._e()
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helpus"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Ошибка Получения данных!")]) : _vm._e(), _vm._v(" "), (_vm.page) ? _c('div', {
    staticClass: "success"
  }, [_c('h3', [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }, [_vm._v(_vm._s(_vm.page.content))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Ошибка Получения данных!")]) : _vm._e(), _vm._v(" "), (_vm.page) ? _c('div', {
    staticClass: "success"
  }, [_c('h3', [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }, [_vm._v(_vm._s(_vm.page.content))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[17]);


// WEBPACK FOOTER //
// static/js/app.c880c472d2a8c750866c.js